export function getLocalStorageKeyForStore<T = any>(
  key: keyof T,
  storeName: string,
  addStorePrefix: boolean = true
): string {
  return `${addStorePrefix ? `${storeName}:` : ''}${key.toString().charAt(0).toUpperCase() + key.toString().slice(1)}`;
}
